import type { ReactElement, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import Spinner from 'app/components/Spinner'
import { useUser } from 'app/utils'
import { useAgentAccess } from './useAgentAccess'

/**
 * Keeps an Agents page to practices that have the agent it is about: Voice needs the AI Agent
 * product, SMS the SMS Agent product, My Agent either. Anyone else goes to /agents, which picks
 * the page they do have. Super users always pass.
 */
const LOADING = (
  <div className="flex justify-center py-16">
    <Spinner size={8} />
  </div>
)

export function AgentsGate({ need, children }: { need: `voice` | `sms` | `any`; children: ReactNode }) {
  const isSuper = useUser()?.type === `super`
  const access = useAgentAccess()
  if (isSuper) return <>{children}</>
  if (access.loading) return LOADING
  const allowed = need === `any` ? access.voice || access.sms : access[need]
  return allowed ? <>{children}</> : <Navigate to="/agents" replace />
}

/** /agents itself: the first agent page the practice has, Voice first. Nothing to show goes home. */
export function AgentsHome(): ReactElement {
  const access = useAgentAccess()
  if (access.loading) return LOADING
  if (access.voice) return <Navigate to="/agents/voice" replace />
  if (access.sms) return <Navigate to="/agents/sms" replace />
  return <Navigate to="/" replace />
}
